var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useTheme } from 'styled-components';
import { SecondaryCTA } from '../styles';
export const SecondaryButton = (_a) => {
    var { color: colorProp } = _a, props = __rest(_a, ["color"]);
    const { colorContext } = useTheme();
    const color = colorProp || (colorContext === 'dark' ? 'white' : 'primary');
    const dataTestId = props['data-testid'] || 'secondary-button--' + color;
    return React.createElement(SecondaryCTA, Object.assign({}, props, { "data-testid": dataTestId }));
};
